import { useRef, useState } from "react";

import MaterialTabbar from "./MaterialTabbar";
import Active from "./Active";
import Archive from "./Archive";

const Materials = () => {
  const [tab, setTab] = useState("Active");
  const activeRef = useRef(null);
  const handleTabChange = (tab) => {
    setTab(tab);
  };
  return (
    <div>
      <MaterialTabbar
        onTabChange={handleTabChange}
        rightSlot={
          tab === "Active" && (
            <div className="flex items-center gap-1 cursor-pointer" onClick={() => activeRef.current?.openAddModal()}>
              <span className="text-[17px] font-OpenSansRegular font-[600] text-subTitleColor">+ </span>
              <span className="text-[12px] font-OpenSansRegular font-[600] text-subTitleColor">Add Material</span>
            </div>
          )
        }
      />
      <div className="p-5">{tab === "Active" ? <Active ref={activeRef} /> : <Archive />}</div>
    </div>
  );
};

export default Materials;
